 
import './App.css';
import { Layout } from './features/pages';

function App() {
  return (
    // <div className="App">
    <div>
          <Layout className="min-h-screen"   />
    </div>
  );
}

export default App;
